import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  CLink,
  CPanel,
  H1,
  H4,
  Text,
  P,
  Caption,
  Box,
  Flex
} from "@appcues/component-library";
import FontIcon from "components/Common/Icons/FontIcon";
import Pill from "components/Common/Pill";

const FREE_TRIAL_LINK =
  "https://docs.appcues.com/article/194-how-the-appcues-free-trial-works";

class TrialMeterPanel extends Component {
  panelHeaderContent = () => {
    const { isInstalled } = this.props;

    return (
      !isInstalled && (
        <Link to="/install">
          <Pill
            fillColor="$purple"
            hoverColor="$purple-dark"
            textColor="$gray-0"
          >
            <FontIcon className="fas fa-magic" />
            <span>Install to start showing flows!</span>
          </Pill>
        </Link>
      )
    );
  };

  render() {
    const {
      createdAt,
      flowsShown,
      flowsShownLimit,
      trialLengthDays
    } = this.props;

    const exceededFlowsShownLimit = flowsShown > flowsShownLimit;
    const flowPercentage = Math.round((flowsShown / flowsShownLimit) * 100, 2);
    let fillColor;

    if (exceededFlowsShownLimit) {
      fillColor = "$red";
    } else if (flowPercentage > 75) {
      fillColor = "$yellow";
    } else {
      fillColor = "$blue";
    }

    const expirationDate = moment(createdAt).add(trialLengthDays, "days");
    const pastTrialExpirationDate = expirationDate < Date.now();
    const trialExpired = exceededFlowsShownLimit && pastTrialExpirationDate;
    // never wider than full-width
    const meterWidth = Math.min(flowPercentage, 100);

    return (
      <CPanel
        renderHeaderContent={this.panelHeaderContent}
        alignItems="flex-start"
      >
        <CPanel.Header>
          <H4 type="secondary">Appcues Free Trial</H4>
        </CPanel.Header>
        <Flex alignItems="baseline" whiteSpace="nowrap">
          <H1>
            {flowsShown}/{flowsShownLimit}
          </H1>
          <Caption type="tertiary">&nbsp; flows shown</Caption>
          <FlowMeterOuter>
            <Box
              width={`${meterWidth}%`}
              backgroundColor={fillColor}
              height="100%"
            />
          </FlowMeterOuter>
        </Flex>
        <P paddingY={15} width="70%">
          {trialExpired ? (
            <span>
              You have exceeded the trial flow limit. To continue showing
              Appcues content, <strong>upgrade to a paid plan below! </strong>
            </span>
          ) : exceededFlowsShownLimit ? (
            <span>
              You have exceeded the trial flow limit.{" "}
              <strong>
                Your trial will remain active until{" "}
                {expirationDate.format("MMMM DD, YYYY")}.
              </strong>{" "}
              At that point, you will need to upgrade to a paid plan to continue
              showing flows.{" "}
            </span>
          ) : (
            <Text whiteSpace="nowrap">
              Your trial will remain active until you have shown{" "}
              {flowsShownLimit} flows. After that, you will need to <br />
              upgrade to a paid plan to continue showing flows.{" "}
            </Text>
          )}
          <CLink isExternal href={FREE_TRIAL_LINK}>
            Learn more.
          </CLink>
        </P>
      </CPanel>
    );
  }
}

export default TrialMeterPanel;

const FlowMeterOuter = styled.div`
  background-color: ${props => props.theme["$gray-3"]};
  border-radius: 100px;
  height: 8px;
  overflow: hidden;
  width: 400px;
  margin-left: 32px;
  margin-top: 8px;
  margin-bottom: 12px;
  align-self: flex-end;
`;
